import { defaultLocale, klingon, } from "./default";
import { enCA } from "./en-ca";
import { enUS } from "./en-us";
export const locales = {
    default: defaultLocale,
    enUS: enUS,
    enCA: enCA,
    klingon,
};
//# sourceMappingURL=locales.js.map